/* global modForm */
import { serviceCodesAndAttributions } from '../../../helpers';

export function initApiErrorFallbackExperience() {
	function getTradePageSlug(service) {
		const serviceCode = serviceCodesAndAttributions.find(item => item.serviceCodes.includes(service));
		return serviceCode && serviceCode.modernizeTradePageSlug ? `/${serviceCode.modernizeTradePageSlug}/` : '/';
	}

	const currentFormData = modForm.opts.formData,
		activeStepInner = modForm.opts.form.querySelector('.swiper-slide-active .step-inner'),
		formButtons = document.querySelectorAll('.form-btns, .form-bts, .controls, .findpros-form__btns'),
		formSecureText = document.querySelectorAll('.secure-text, .step__secure-text'),
		formTcpa = document.querySelector('.form-tcpa'),
		tradeSlug = getTradePageSlug(currentFormData.service),
		initialPageParams = window.location.search,
		resultsPageUrl = `https://modernize.com${tradeSlug}${initialPageParams}${initialPageParams ? '&' : '?'}zip=${currentFormData.zip}&${modForm.opts.suppressConversionPixelParam}#open-findpros-modal`,
		headerCallNumber = document.querySelector('.header__call-number'),
		headerCallNumberText = headerCallNumber?.textContent;

	modForm.opts.form.classList.add(modForm.opts.formLoadingCls);

	if (modForm.opts.backButtons) {
		modForm.opts.backButtons.forEach(function(backButton) {
			backButton.style.display = 'none';
		});
	}
	if (modForm.opts.progressBar) {
		modForm.opts.progressBar.forEach(function(bar) {
			bar.style.display = 'none';
		});
	}
	if (formButtons) {
		formButtons.forEach(function(formButton) {
			formButton.style.display = 'none';
		});
	}
	if (formSecureText) {
		formSecureText.forEach(function(secureText) {
			secureText.style.display = 'none';
		});
	}
	if (formTcpa) {
		formTcpa.style.display = 'none';
	}

	modForm.opts.form.querySelector('.swiper-wrapper').style.alignItems = 'center';
	modForm.opts.form.classList.remove(modForm.opts.formLoadingCls);

	const target = modForm.opts.isLeadWidget ? '_blank' : '_self';

	activeStepInner.innerHTML = `<div class="duplicate-submission" style="background-color:#fff;display:flex; flex-direction:column;justify-content:center;align-items:center;min-height:450px;padding:40px 10px;text-align:center;"><h3 style="color:#545253;font-size:22px;font-weight:bold;line-heigh:1.25;margin:30px auto 0;">Oops, Looks Like There Was a Small&nbsp;Error!</h3><p style="color:#545253;display:block;font-size:15px;font-weight:400;line-height:1.35;margin:20px auto 30px;">It seems like we encountered a hiccup during your submission, but no worries &mdash; you’re almost&nbsp;there!<br>We’ll redirect you to Modernize.com to complete your&nbsp;request.</p><a class="btn ${modForm.opts.addAccessibilityUpdates ? 'btn--primary' : 'btn-primary'}" id="double-submission-fallback-button" href="${resultsPageUrl}" target="${target}" style="height:auto;max-width:fit-content;line-height:normal;width:100%;padding:14px 20px 15px;margin:0 auto 30px;min-width:unset;"><span class="btn__text" style="visibility:visible;font-size: 18px">Continue to Modernize</span></a>${modForm.opts.phoneAssignmentConfig.response || headerCallNumber ? `<p style="color:#545253;font-size:15px;font-weight:400;margin:0 auto 30px;">For fastest service, call <a id="double-submission-fallback-call-button" href="tel:${modForm.opts.phoneAssignmentConfig.response ? modForm.opts.phoneAssignmentConfig.response.hrefPhoneNumber : headerCallNumberText.replace(/\D/g, '')}" style="color:inherit;text-decoration:underline;">${modForm.opts.phoneAssignmentConfig.response ? modForm.opts.phoneAssignmentConfig.response.displayNumber : headerCallNumberText}</a> now!</p>` : ''}</div>`;
}
